const INIT_ATTR = 'data-account-init';
const CLOSE_DELAY = 150;
const VIEWPORT_MARGIN = 124;

/** @param {HTMLElement} trigger @param {HTMLElement} panel */
function positionPanel(trigger, panel) {
  const header = document.getElementById('header-component');
  const triggerRect = trigger.getBoundingClientRect();
  const top = header ? header.getBoundingClientRect().bottom : triggerRect.bottom;
  panel.style.top = `${top}px`;

  const vw = window.innerWidth;
  const panelWidth = panel.offsetWidth;
  let left = triggerRect.left;

  if (panelWidth > 0) {
    const maxLeft = vw - VIEWPORT_MARGIN - panelWidth;
    left = Math.min(Math.max(left, VIEWPORT_MARGIN), maxLeft);
  }

  panel.style.left = `${left}px`;
}

/** @param {HTMLElement} trigger @param {HTMLElement} panel */
function openPanel(trigger, panel) {
  panel.removeAttribute('hidden');
  trigger.setAttribute('aria-expanded', 'true');
  positionPanel(trigger, panel);
  requestAnimationFrame(() => positionPanel(trigger, panel));
}

/** @param {HTMLElement} trigger @param {HTMLElement} panel */
function closePanel(trigger, panel) {
  panel.setAttribute('hidden', '');
  trigger.setAttribute('aria-expanded', 'false');
}

/** @param {HTMLElement} root */
function initAccountDropdown(root) {
  if (root.hasAttribute(INIT_ATTR)) return;
  root.setAttribute(INIT_ATTR, '');

  const trigger = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-trigger]'));
  const panel = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-panel]'));
  if (!trigger || !panel) return;

  /** @type {ReturnType<typeof setTimeout> | null} */
  let closeTimer = null;

  const scheduleClose = () => {
    closeTimer = setTimeout(() => closePanel(trigger, panel), CLOSE_DELAY);
  };

  const cancelClose = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  trigger.addEventListener('mouseenter', () => {
    cancelClose();
    openPanel(trigger, panel);
  });

  trigger.addEventListener('mouseleave', scheduleClose);

  panel.addEventListener('mouseenter', cancelClose);
  panel.addEventListener('mouseleave', scheduleClose);

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    panel.hasAttribute('hidden') ? openPanel(trigger, panel) : closePanel(trigger, panel);
  });
}

/** @param {ParentNode} root */
function initAccountDropdowns(root) {
  root.querySelectorAll('[data-account-dropdown]').forEach((el) =>
    initAccountDropdown(/** @type {HTMLElement} */ (el))
  );
}

document.addEventListener('click', (e) => {
  document.querySelectorAll(`[data-account-dropdown][${INIT_ATTR}]`).forEach((root) => {
    const panel = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-panel]'));
    const trigger = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-trigger]'));
    if (panel && trigger && !root.contains(/** @type {Node} */ (e.target))) {
      closePanel(trigger, panel);
    }
  });
});

document.addEventListener('keydown', (e) => {
  if (/** @type {KeyboardEvent} */ (e).key !== 'Escape') return;
  document.querySelectorAll(`[data-account-dropdown][${INIT_ATTR}]`).forEach((root) => {
    const panel = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-panel]'));
    const trigger = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-trigger]'));
    if (panel && trigger && !panel.hasAttribute('hidden')) {
      closePanel(trigger, panel);
    }
  });
});

window.addEventListener('resize', () => {
  document.querySelectorAll(`[data-account-dropdown][${INIT_ATTR}]`).forEach((root) => {
    const panel = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-panel]'));
    const trigger = /** @type {HTMLElement | null} */ (root.querySelector('[data-account-trigger]'));
    if (panel && trigger && !panel.hasAttribute('hidden')) {
      positionPanel(trigger, panel);
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) {
    initAccountDropdowns(event.target);
  }
});

initAccountDropdowns(document);
